import { pullAllWith } from "lodash-es";

import { RouteConfig } from "./router-config.model";

/**
 * Remove disabled routes from the configuration.
 * Note: this method changes `routes` input.
 */
export function removeDisabledRoutes(routes: RouteConfig[], disabledRoutes: string[] | undefined): RouteConfig[] {
	if (!disabledRoutes || disabledRoutes.length === 0) {
		return routes;
	}
	return pullAllWith(routes, disabledRoutes, (route, disableRoute) => route.name === disableRoute);
}
